import React, { useState, useEffect } from 'react';
import './Contact.css';
import ENV from '../constants/env-constants';
import ReactGA from "react-ga4";
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function Contact() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    country: '',
    company: '',
    comment: ''
  });
  const location = useLocation()
  useEffect(()=>{
    ReactGA.send({ hitType: "pageview", page: location.pathname, title: 'Contact Page' });
  }, []);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${ENV.API_URL}/api/contactform`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        alert('Thank you for your message. We will get back to you shortly.');
        setFormData({ firstName: '', lastName: '', email: '', phone: '', country: '', company: '', comment: '' });
      } else {
        alert('There was a problem with your submission. Please try again.');
      }
    } catch (error) {
      console.error('Submission error:', error);
      alert('Error sending message. Please try again later.');
    }
  };

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Contact</title>
      </Helmet>
      <div className="contact-section">
        <div className="row">
          <div className="col-lg-5 image-container">
            <img src="/img/img/Community_Childrem.png" alt="Community Children" />
          </div>
          <div className="col-lg-7 form-container">
            <form onSubmit={handleSubmit}>
              <h2>Contact Us</h2>
              <p>Have a question or comment for us? Want more information about a location or what we do? Seek opportunities to volunteer or join one of our community programs? Please let us know and fill out this form:</p>
              
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="firstName">First Name:<span className="required-star">*</span></label>
                  <input type="text" id="firstName" name="firstName" required value={formData.firstName} onChange={handleChange} />
                </div>
                <div className="form-group">
                  <label htmlFor="lastName">Last Name:<span className="required-star">*</span></label>
                  <input type="text" id="lastName" name="lastName" required value={formData.lastName} onChange={handleChange} />
                </div>
              </div>

  <div className="form-row">
    <div className="form-group">
      <label htmlFor="email">Email:<span className="required-star">*</span></label>
      <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} />
    </div>
    <div className="form-group">
      <label htmlFor="phone">Phone Number:</label>
      <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} />
    </div>
  </div>

              <label htmlFor="company">Company or Organization:</label>
              <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} />

              <label htmlFor="country">Country:</label>
              <select value="" id="country" name="country" onChange={handleChange}>
                <option value="" disabled>-- Please Choose The Country --</option>
                <option>United States</option>
                <option>Australia</option>
                <option>Canada</option>
                <option>New Zealand</option>
                <option>South Africa</option>
                <option>United Kingdom</option>
              </select>

              <label htmlFor="comment">Comment(s) or Questions(s):</label>
              <textarea id="comment" name="comment" rows={4} value={formData.comment} onChange={handleChange} />

              <button type="submit" className="btn btn-primary">Send Message</button>
            </form>
          </div>
        </div>
      </div>
      <a href="#" className="btn btn-lg btn-primary btn-lg-square rounded-circle back-to-top"><i className="bi bi-arrow-up" /></a>
    </div>
  );
}

export default Contact;